import React from 'react';
import { useTranslation } from "react-i18next";

function QayindySightPage(props) 
{
    const { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <h1 className="uk-heading-medium uk-margin-bottom">
                {t("Qayindy.title", "Qayindy Lake")}
            </h1>

            <p className="uk-text-lead uk-margin-bottom">
                {t(
                    "Qayindy.intro",
                    "Qayindy Lake, located in the Almaty Region of Kazakhstan, is famous for its sunken forest. Formed after an earthquake in 1911, the lake submerged a spruce grove, leaving the tops of the trees visible above the water, while their trunks remain preserved underwater."
                )}
            </p>

            <h2 className="uk-heading-line uk-text-bold">
                <span>{t("Qayindy.highlightsTitle", "Highlights")}</span>
            </h2>
            <ul className="uk-list uk-list-bullet uk-margin-bottom">
                <li>{t("Qayindy.highlight1", "The submerged forest, with tree trunks rising mysteriously from the turquoise waters.")}</li>
                <li>{t("Qayindy.highlight2", "Unique underwater landscape, popular among divers and photographers.")}</li>
                <li>{t("Qayindy.highlight3", "Surrounding spruce forests and mountains offering hiking opportunities.")}</li>
                <li>{t("Qayindy.highlight4", "Part of the Kolsai Lakes National Park, allowing combined visits with nearby lakes.")}</li>
            </ul>

            <p className="uk-text uk-text-justify">
                {t(
                    "Qayindy.conclusion",
                    "Qayindy Lake is a natural wonder with a mystical atmosphere, attracting travelers who seek unusual and unforgettable landscapes in Kazakhstan."
                )}
            </p>
        </div>
    );
}

export default QayindySightPage;
